import {
  GET_SELL_LIMITS, GET_SELL_LIMITS_COMPLETED, GET_SELL_LIMITS_FAILED,
  ADD_SELL_LIMIT, ADD_SELL_LIMIT_COMPLETED, ADD_SELL_LIMIT_FAILED,
  GET_SELL_LIMIT, GET_SELL_LIMIT_COMPLETED, GET_SELL_LIMIT_FAILED,
  SEARCH_SELL_LIMITS, SEARCH_SELL_LIMITS_COMPLETED, SEARCH_SELL_LIMITS_FAILED,
} from './actions';
import {firstPage, getPaginationOrDefault} from "../utils/pagination";
import {AUTH_LOGOUT} from "../Auth/actions";
import {handleSearch, handleSearchCompleted, handleSearchFailed, searchDefault} from "../utils/search";

const defaultState = {
  sellLimitsLoading: false,
  sellLimits: [],
  sellLimitsPagination: firstPage,
  sellLimitsError: null,
  sellLimitLoading: true,
  sellLimit: null,
  sellLimitError: null,
  search: searchDefault,
};

const sellLimitReducer = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case GET_SELL_LIMITS: {
      const sellLimitsLoading = true;
      return {
        ...state,
        sellLimitsLoading
      };
    }
    case GET_SELL_LIMITS_COMPLETED: {
      const sellLimitsLoading = false;
      const sellLimits = action.payload.data;
      const sellLimitsPagination = getPaginationOrDefault(action.payload);
      return {
        ...state,
        sellLimitsLoading,
        sellLimits,
        sellLimitsPagination,
      };
    }
    case GET_SELL_LIMITS_FAILED: {
      const sellLimitsLoading = false;
      const sellLimitsError = action.payload;
      return {
        ...state,
        sellLimitsLoading,
        sellLimitsError
      };
    }
    case GET_SELL_LIMIT: {
      return {...state, sellLimitLoading: true};
    }
    case GET_SELL_LIMIT_COMPLETED: {
      return {...state, sellLimitLoading: false, sellLimit: action.payload};
    }
    case GET_SELL_LIMIT_FAILED: {
      return {...state, sellLimitLoading: false, sellLimitError: action.payload};
    }
    case ADD_SELL_LIMIT:
      return state;
    case ADD_SELL_LIMIT_COMPLETED:
      return state;
    case ADD_SELL_LIMIT_FAILED:
      return state;
    case AUTH_LOGOUT: {
      return defaultState;
    }
    case SEARCH_SELL_LIMITS: return handleSearch(state, 'search', action.payload);
    case SEARCH_SELL_LIMITS_COMPLETED: return handleSearchCompleted(state, 'search', action.payload);
    case SEARCH_SELL_LIMITS_FAILED: return handleSearchFailed(state, 'search', action.payload);
    default:
      return state;
  }
};

export default sellLimitReducer;



// WEBPACK FOOTER //
// ./src/SellLimit/reducer.js